import React from "react";
import Chart from "react-apexcharts";
import { Card, Col, Container, Form, ProgressBar, Row } from "react-bootstrap";

const DatabaseLockReadiness = () => {
  const overallProgress = 12;

  const siteData = [
    { site: "Site 01", value: 22 },
    { site: "Site 02", value: 12 },
    { site: "Site 03", value: 7 },
    { site: "Site 04", value: 0 },
    { site: "Site 05", value: 10 },
    { site: "Site 06", value: 14 },
    { site: "Site 07", value: 18 },
  ];

  const chartOptions = {
    chart: {
      type: "radialBar",
      sparkline: {
        enabled: true,
      },
    },

    colors: ["#e52b2b"],

    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 270,

        hollow: {
          size: "72%",
        },

        track: {
          background: "#e5eaf2",
        },

        dataLabels: {
          name: {
            show: true,
            offsetY: 18,
            color: "#6b7280",
            fontSize: 12,
          },

          value: {
            offsetY: -15,
            fontSize: 35,
            fontWeight: 700,
            formatter: (val) => `${parseInt(val)}%`,
          },
        },
      },
    },

    labels: ["STUDY DBL"],
  };

  return (
    <Container fluid>
      <Row>
        {/* Left Donut */}

        <Form.Group as={Col} md={3} className="text-center">
          <Chart
            options={chartOptions}
            series={[overallProgress]}
            type="radialBar"
            height={180}
          />
        </Form.Group>

        {/* Right Progress */}

        <Form.Group as={Col} md={9} className="text-center">
          {siteData.map((item) => (
            <div key={item.site} className="hstack gap-2 mb-1">
              <div
                style={{
                  width: 80,
                  fontSize: 13,
                }}
              >
                {item.site}
              </div>

              <div className="flex-grow-1">
                <ProgressBar
                  now={item.value}
                  variant="danger"
                  style={{
                    height: 7,
                    background: "#e5eaf2",
                  }}
                />
              </div>

              <div
                style={{
                  width: 40,
                  textAlign: "right",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {item.value}%
              </div>
            </div>
          ))}
        </Form.Group>
      </Row>
    </Container>
  );
};

export default DatabaseLockReadiness;
